import ModelProxy, {required, optional} from './proxy';


export class RawMutation extends ModelProxy {

  static propTypes = {
    position: required,
    AAs: required,
    triplet: optional,
    isInsertion: required,
    insertedNAs: required,
    isSDRM: required,
    isUnusual: required,
    isApobecMutation: required,
    isAmbiguous: required,
    primaryType: required,
    hasStop: required,
    shortText: required
  };

}


export class RawGeneAlignment extends ModelProxy {

  static propTypes = {
    firstAA: required,
    lastAA: required,
    gene: required,
    alignedNAs: required,
    alignedAAs: required,
    mutations: required
  };

  static setMutations(self, value) {
    self.props.mutations = value.map(v => (
      v instanceof RawMutation ?
        v : new RawMutation(v)
    ));
  }

}


export default class RawAlignment extends ModelProxy {

  static propTypes = {
    rawSequenceUuid: required,
    uuid: required,
    subtype: required,
    species: required,
    validationResults: required,
    geneSequences: required
  };

  static setGeneSequences(self, value) {
    self.props.geneSequences = value.map(v => (
      v instanceof RawGeneAlignment ?
        v : new RawGeneAlignment(v)
    ));
  }

  static getSpecies(self) {
    let {species} = self.props;
    if (!species) {
      return null;
    }
    if (/HIV-?2|HUMAN IMMUNODEFICIENCY VIRUS (?:TYPE )?2/i.test(species)) {
      species = 'HIV2';
    }
    else if (/HIV|HUMAN IMMUNODEFICIENCY VIRUS/i.test(species)) {
      species = 'HIV1';
    }
    else if (/SIV|SIMIAN IMMUNODEFICIENCY VIRUS/i.test(species)) {
      species = 'NHPL';
    }
    return species;
  }

}



// WEBPACK FOOTER //
// ./src/models/raw-alignment.js